import {EntityRota} from './entity-rota.model';
import {actions} from '~utils/ngrx-util';

const entityName = 'EntityRota';
const {add, adds, upsert, upserts, update, updates, remove, removes, load, clear} = actions<EntityRota>(entityName);

export const addEntityRota = add;
export const addEntityRotas = adds;
export const upsertEntityRota = upsert;
export const upsertEntityRotas = upserts;
export const updateEntityRota = update;
export const updateEntityRotas = updates;
export const deleteEntityRota = remove;
export const deleteEntityRotas = removes;
export const loadEntityRotas = load;
export const clearEntityRotas = clear;
